require('./src/js/script');
